import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CancelShipmentReasonsFilterEntity } from '../../domain/entities/CancelShipmentReasonsFilterEntity'

export class CancelShipmentReasonsFilterModel extends CancelShipmentReasonsFilterEntity {
  constructor(dataDto: CancelShipmentReasonsFilterEntity) {
    super()
    mapEntityProperties<CancelShipmentReasonsFilterModel>(this, dataDto)
  }
}
